import { create } from 'zustand'
import { MainStore } from './types'

const useStore = create<MainStore>( ( set, get ) => ( {
    session: null,
    setSession: ( session ) => set( { session } ),

    activePage: null,
    setActivePage: ( activePage ) => set( { activePage } ),

    accessToken: '',
    setAccessToken: ( accessToken ) => set( { accessToken, isLogin: true } ),

    isLogin: false,
    setIsLogin: ( isLogin ) => set( { isLogin }  )
} ) )

export default useStore